const generateGraphic = (shape = {}, style = {}, otherOp = {}) => ({
  type: 'rect',
  z: 1,
  top: 25,
  shape: {
    x: 60,
    height: 30,
    ...shape,
  },
  style: {
    fill: '#F6F6F6',
    lineWidth: 0,
    ...style,
  },
  ...otherOp,
});

export default generateGraphic;
